import { apiRequest } from "api";
import { BASE_URL } from "constants/routes";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { encryptPayload } from "./encrypt";

  export const saveDraft = createAsyncThunk(
    "fetchApi/saveDraft",
    async (params) => {
      const req = `${BASE_URL}/email/saveDraft`;
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",

        },
        body:JSON.stringify(params)
      };
  
      try {
        const result = await apiRequest(req, options,true);
        return result.data;
      } catch (err) {
        console.log(err);
      }
    }
  );